export const PRINT_CHECKOUT_ATTEMPT_STORAGE_KEY = 'bloomup.printCheckoutAttempt.v1';

const getStorage = (storage) => storage || window.localStorage;

export const createPrintCartIdentity = (cart) =>
  JSON.stringify(
    (Array.isArray(cart) ? cart : []).map((line) => ({
      clientLineItemId: line.clientLineItemId,
      printId: line.printId,
      fulfillmentKind: line.fulfillmentKind,
      outputFormat: line.outputFormat,
      binding: line.binding,
      format: line.format,
      productType: line.productType,
      contentFinish: line.contentFinish,
      quantity: line.quantity,
      totalPages: line.totalPages,
      previewToken: line.previewToken,
    }))
  );

export const loadPrintCheckoutAttempt = (cart, storage) => {
  try {
    const serialized = getStorage(storage).getItem(PRINT_CHECKOUT_ATTEMPT_STORAGE_KEY);
    if (!serialized) return null;
    const attempt = JSON.parse(serialized);
    if (
      !attempt ||
      attempt.version !== 1 ||
      typeof attempt.checkoutAttemptId !== 'string' ||
      attempt.cartIdentity !== createPrintCartIdentity(cart)
    ) {
      return null;
    }
    return attempt;
  } catch (error) {
    return null;
  }
};

export const savePrintCheckoutAttempt = (cart, checkoutAttemptId, paymentDraftId = null, storage) => {
  if (!checkoutAttemptId || !Array.isArray(cart) || cart.length === 0) return { ok: false, reason: 'invalid-attempt' };
  try {
    getStorage(storage).setItem(
      PRINT_CHECKOUT_ATTEMPT_STORAGE_KEY,
      JSON.stringify({
        version: 1,
        cartIdentity: createPrintCartIdentity(cart),
        checkoutAttemptId,
        paymentDraftId: paymentDraftId || null,
      })
    );
    return { ok: true };
  } catch (error) {
    return { ok: false, reason: 'storage-error' };
  }
};

export const clearPrintCheckoutAttempt = (storage) => {
  try {
    getStorage(storage).removeItem(PRINT_CHECKOUT_ATTEMPT_STORAGE_KEY);
    return { ok: true };
  } catch (error) {
    return { ok: false, reason: 'storage-error' };
  }
};
